import { Button } from '@telegram-apps/telegram-ui'
import { CircleAlert, RotateCcw } from 'lucide-react'
import { useTranslate } from 'shared/lib/i18n'

export function FeedErrorState({ onRetry }: { onRetry: () => void }) {
	const { t } = useTranslate()
	return (
		<div className="flex flex-col items-center gap-2 px-10 py-14 text-center">
			<div className="mb-1.5 grid size-[76px] place-items-center rounded-full bg-[rgba(241,46,46,0.15)] text-[var(--tgui--destructive_text_color,rgb(229,57,53))]">
				<CircleAlert className="size-9" />
			</div>
			<div className="text-[19px] font-semibold text-[var(--tgui--text_color,#fff)]">
				{t('errors.loadFailed')}
			</div>
			<div className="max-w-60 text-[15px] leading-snug text-[var(--tgui--hint_color,rgb(170,170,170))]">
				{t('errors.connectionRetry')}
			</div>
			<Button
				size="m"
				className="mt-3.5"
				before={<RotateCcw className="size-[19px]" />}
				onClick={onRetry}
			>
				{t('common.retry')}
			</Button>
		</div>
	)
}
